import React from 'react';
import { Box, Typography, Button, Container, useTheme, Paper } from '@mui/material';
import { ArrowBack as ArrowBackIcon, ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';

const NotFoundPage: React.FC = () => {
 const theme = useTheme();

 const handleGoBack = () => {
   window.history.back();
 };

 return (
   <Container maxWidth="md">
     <Box
       sx={{
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'center',
         justifyContent: 'center',
         minHeight: '80vh',
         textAlign: 'center',
         py: 4
       }}
     >
       <Paper
         elevation={1}
         sx={{
           p: 4,
           borderRadius: 2,
           backgroundColor: theme.palette.background.paper,
           maxWidth: 500,
           width: '100%'
         }}
       >
         <Box
           sx={{
             mb: 3,
             display: 'flex',
             justifyContent: 'center'
           }}
         >
           <ErrorOutlineIcon
             sx={{
               fontSize: 80,
               color: theme.palette.primary.main
             }}
           />
         </Box>

         <Typography
           variant="h1"
           sx={{
             fontSize: '6rem',
             fontWeight: 700,
             color: theme.palette.primary.main,
             mb: 2,
             lineHeight: 1
           }}
         >
           404
         </Typography>

         <Typography
           variant="h4"
           sx={{
             fontWeight: 600,
             mb: 2,
             color: theme.palette.text.primary
           }}
         >
           Page Not Found
         </Typography>

         <Typography
           variant="body1"
           sx={{
             mb: 4,
             color: theme.palette.text.secondary,
             fontSize: '1.1rem'
           }}
         >
           The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
         </Typography>

         <Button
           variant="contained"
           startIcon={<ArrowBackIcon />}
           onClick={handleGoBack}
           sx={{
             px: 3,
             py: 1.5,
             fontSize: '0.875rem',
             fontWeight: 600
           }}
         >
           Go Back
         </Button>
       </Paper>
     </Box>
   </Container>
 );
};

export default NotFoundPage;